import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ReactComponent as ChatLimitIcon } from "../../../../../assets/images/People/Customers/conversations.svg";
import { ReactComponent as TimezoneIcon } from "../../../../../assets/images/People/Customers/timezone.svg";
import CustomerDetailInfoField from "../../Customers/CustomerDetail/CustomerDetailInfoField";
import { sectionCardSx, sectionTitleSx } from "./agentDetailSectionStyles";

export default function AgentDetailChatSettingsSection({ agent }) {
  const leftFields = [
    { icon: ChatLimitIcon, label: "Chat Limit", value: agent.chatLimit },
  ];

  const rightFields = [
    { icon: TimezoneIcon, label: "Timezone", value: agent.timezone },
  ];

  return (
    <Box sx={{ mb: 3 }}>
      <Typography sx={sectionTitleSx}>Chat Settings</Typography>
      <Box sx={sectionCardSx}>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
            gap: 3,
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            {leftFields.map((field) => (
              <CustomerDetailInfoField key={field.label} {...field} />
            ))}
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            {rightFields.map((field) => (
              <CustomerDetailInfoField key={field.label} {...field} />
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
